import React from 'react';

import { EnterpriseSignup } from 'src/enterprise/signup';
import { EnterpriseLayout } from 'src/components/layouts/enterprise-layout';
import { PageComponent } from 'src/types';

const EnterpriseLoyaltySignupPage: PageComponent = () => <EnterpriseSignup />;

EnterpriseLoyaltySignupPage.layout = EnterpriseLayout;

export default EnterpriseLoyaltySignupPage;
